import React from "react";

export function AppliesTo() {
	return (
		<section className="space-y-3">
			<h2 className="text-15/[22px] text-core-text-neutral-primary">Applies to</h2>
			<p className="mb-0 text-core-text-neutral-secondary">
				This silencing rule applies exclusively to the current status of this monitor, on the current component only.
			</p>
		</section>
	);
}
